type SplitParagraphsProps = {
  paragraph?: string;
  prefix?: string;
};

const SplitParagraphs = ({ paragraph, prefix }: SplitParagraphsProps) => {
  return (
    <>
      {paragraph?.split("\n").map((val, index) => (
        <p key={index}>
          {index === 0 && prefix && <>{prefix} </>}
          {val}
        </p>
      ))}
    </>
  );
};

export default SplitParagraphs;
